// components/layout/DefaultTreeRedirect.tsx — Redirects to the last-visited tree
// (falling back to the 'me' alias the backend resolves to the user's own tree).

import { Navigate } from 'react-router-dom';
import { useAppStore } from '@/store';

export function DefaultTreeRedirect() {
  const activeTreeId = useAppStore((s) => s.activeTreeId);
  return <Navigate to={`/trees/${activeTreeId ?? 'me'}`} replace />;
}
